import { useContext } from 'react';
import { LookContext, type LookValue } from './look';

const MERIDIAN: LookValue = {
  colours: {},
  applyColours: () => {},
};

/** Meridian and no-ops outside a LookProvider, as useSelectedTenant answers "no organisation". */
export function useLook(): LookValue {
  return useContext(LookContext) ?? MERIDIAN;
}
